<template>
  <div v-if="dayNews">
    <div class="mt-3 d-flex flex-column flex-grow-1">
      <div class="atento-title">
        <div class="title">ATENTO</div>
        <div class="real-time">TIEMPO REAL</div>
      </div>
      <div class="sect-atentos flex-grow-1">
        <div class="time-line">
          <day-news-feed-item
            v-for="item in dayNews.feed"
            :key="item.id"
            :item="item"
          ></day-news-feed-item>
        </div>
      </div>
      <div class="row flex-shrink-1">
        <div class="col">
          <div class="button">
            <a href="/atento" class="btn">MÁS INFORMACIÓN</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DayNewsFeedItem from "../day-news-feed-item/DayNewsFeedItem.vue";
export default {
  components: { DayNewsFeedItem },
  created: function () {
    this.$refreshHub.$on("atento-update", this.getDayNews);
    this.getDayNews();
  },
  methods: {
    getDayNews: function () {
      var _self = this;
      axios.get("/api/daynews").then(function (d) {
        _self.dayNews = d.data;
      });
    },
  },
  data: function () {
    return {
      dayNews: null,
    };
  },
};
</script>